import { useLexicalComposerContext } from '@lexical/react/LexicalComposerContext'
import type { LexicalNode, NodeKey } from 'lexical'
import { $getNodeByKey } from 'lexical'
import { useCallback } from 'react'

type UpdateNodeCallback<T extends LexicalNode> = (node: T) => void
type UseUpdateNodeReturn<T extends LexicalNode> = {
    updateNode: (cb: UpdateNodeCallback<T>) => void
}

export const useUpdateNode = <T extends LexicalNode>(
    nodeKey: NodeKey,
): UseUpdateNodeReturn<T> => {
    const [editor] = useLexicalComposerContext()
    const updateNode = useCallback(
        (cb: UpdateNodeCallback<T>) => {
            editor.update(
                () => {
                    const node = $getNodeByKey(nodeKey)
                    cb(node as T)
                },
                { tag: 'skip-scroll-into-view' },
            )
        },
        [editor, nodeKey],
    )
    return {
        updateNode,
    }
}
